module.exports = __webpack_public_path__ + "img/mc-n1.cd21ca76.gif";